module.exports = __webpack_public_path__ + "static/media/Logo_EPS_300.1ed3b08b.png";